import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

const ButtonWrapper = styled.button`
  color: var(--accent-text);
  outline: 0;
  width: 140px;
  margin: 0 20px;
  background: #F7FAFC;
  height: 40px;

  font-family: Metropolis, serif;

  border: 1px solid #CBD5E0;
  box-sizing: border-box;
  border-radius: 4px;
  padding: var(--space-s) 0;
  outline: none;
  white-space: nowrap;
  cursor: pointer;
  font-weight: 500;
  font-size: var(--font-xs);
  transition: 0.2s background-color ease-in;

  -webkit-user-select: none;

  &:disabled {
    background-color: var(--gray-primary);
    color: var(--font-secondary);
  }

  &:hover::before {
    background-color: var(--gray-secondary);
  }

  &:active {
    outline: 0;
  }

  &::before {
  }
`;

function ActionButton5(
    {
        onClick = () => {
        },
        disabled = false,
        ...props
    }
) {
    return (
        <ButtonWrapper onClick={onClick} disabled={disabled}>
            {props.children}
        </ButtonWrapper>
    );
}

ActionButton5.propTypes = {onClick: PropTypes.func.isRequired, disabled: PropTypes.bool};
ActionButton5.defaultProps = {};

export default ActionButton5;
